import {
  GetLivePricesRequestQueryStringParamsType,
  STRIPE_LATEST_PRODUCT_VERSION,
  StripeProductVersion,
} from "@intelligems/ig-types";
import { GetLivePricesResponseBodyType } from "@intelligems/ig-types/functions/intelligems/get-live-prices";
import { useGetOrganizationSummary } from "@src/api/organization-summaries/get-organization-summary";
import { useQuery } from "@tanstack/react-query";

import { api } from "../api";
import { intelligemsKeys } from "../queryKeys";

export const getLivePrices = async (version: StripeProductVersion) => {
  const resp = await api.get<
    GetLivePricesResponseBodyType,
    GetLivePricesRequestQueryStringParamsType
  >(`/v2/intelligems/prices?version=${version}`);
  return resp.data;
};

export const useCurrentPriceVersion = () => {
  const adminOrg = useGetOrganizationSummary();

  return (
    adminOrg.data.org.stripeSubscriptionSummaries
      .filter(
        (ss) =>
          ss.status === "active" ||
          ss.status === "trialing" ||
          ss.status === "pending"
      )
      .flatMap((os) => os.version)
      .sort()
      .pop()! || STRIPE_LATEST_PRODUCT_VERSION
  );
};

export const useGetLivePrices = () => {
  const version = useCurrentPriceVersion();
  return useQuery<GetLivePricesResponseBodyType, Error>({
    queryKey: intelligemsKeys.livePrices,
    queryFn: async () => getLivePrices(version),
  });
};
